import { READ_WORKER_REPORT_FILTERS_FAILURE, READ_WORKER_REPORT_FILTERS_REQUEST, READ_WORKER_REPORT_FILTERS_SUCCESS, WorkerReportFiltersActionTypes, WorkerReportFiltersState } from 'store/reducers/types/workerReport/workerReportFilters';

const defaultState: WorkerReportFiltersState = {
  isLoading: false,
  errorMessage: ""
};

export default function workerReportFilters(state = defaultState, action: WorkerReportFiltersActionTypes): WorkerReportFiltersState {
  switch (action.type) {
    case READ_WORKER_REPORT_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_WORKER_REPORT_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_WORKER_REPORT_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};